var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F8F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55385 5.29625L7.38065 4.12305C5.41135 5.62456 4.11483 7.93834 4 10.564H5.641C5.76432 8.3897 6.87969 6.48616 8.55385 5.29625ZM18.7205 10.564H20.3615C20.2384 7.93862 18.9419 5.62456 16.9811 4.12305L15.8158 5.29625C17.4733 6.48616 18.5974 8.3897 18.7207 10.564H18.7205ZM17.1041 10.9742C17.1041 8.45519 15.7586 6.3464 13.4116 5.78844V5.23102C13.4119 5.06934 13.3802 4.90919 13.3185 4.75976C13.2567 4.61033 13.1661 4.47454 13.0518 4.36019C12.9375 4.24584 12.8018 4.15516 12.6524 4.09335C12.503 4.03154 12.3428 3.99982 12.1811 4C12.0194 3.99975 11.8592 4.03142 11.7098 4.09319C11.5603 4.15497 11.4245 4.24563 11.3101 4.36C11.1958 4.47436 11.1051 4.61016 11.0433 4.75963C10.9815 4.9091 10.9499 5.06929 10.9501 5.23102V5.78871C8.59523 6.34695 7.25788 8.44725 7.25788 10.9745V15.077L5.61661 16.7183V17.5388H18.7451V16.7183L17.1041 15.0773V10.9748V10.9742ZM12.1806 20C12.2957 20 12.4023 19.9918 12.5089 19.9671C12.7688 19.9117 13.0117 19.7949 13.2172 19.6265C13.4227 19.4581 13.585 19.2429 13.6903 18.9989C13.7725 18.8021 13.8136 18.5887 13.8136 18.359H10.5311C10.5393 19.2617 11.2699 20 12.1806 20Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsActive);
export default __webpack_public_path__ + "static/media/notifications_active.b43190d7408c8829380f535987fbc062.svg";
export { ForwardRef as ReactComponent };